import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';

const {get} = requestWrapper;

const requests = {
	// TODO : check if still used + type response
	resetSession: () => get<any>(endpoints.resetSession),
};

export default requests;
